import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { createWarehouse, editWarehouse, fetchWarehouseDetail } from '../../actions/warehouses_actions';

import WarehouseForm from '../../components/Inventories/warehouseForm';

const validate = values => {
  const errors = {}
  if (!values.Name) {
    errors.Name = 'Required'
  }
  return errors
}

let warehouseForm = reduxForm({
  form: 'warehouseForm',
  validate
})(WarehouseForm);

// const selector = formValueSelector('warehouseForm')

function mapStateToProps(state) {
  return {
    currentWarehouse: state.warehouses.currentWarehouse,
    initialValues: state.warehouses.currentWarehouse,
    isCreating: state.warehouses.isCreating,
    createError: state.warehouses.createError,
    created: state.warehouses.created,
    isEditing: state.warehouses.isEditing,
    editError: state.warehouses.editError,
    edited: state.warehouses.edited,
    userPermissions: state.auth.userPermissions
  }
}

export default connect(mapStateToProps, { createWarehouse, editWarehouse, fetchWarehouseDetail })(warehouseForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/warehouseForm.jsx